import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: {
        id: string
    }
}

const { onRequest, onSuccess, onFailure } = rootActions.quotations.one
function* oneQuotationSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/quotations/one/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneQuotationSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneQuotationSagaTask)
}

export default oneQuotationSaga
